<template>
    <div class="d-flex flex-column h-100"> 
        <div id="wrapper" v-if="isUserAuthenticated">
            <doctor-sidebar />
            <div id="content-wrapper" class="d-flex flex-column">
                <div id="content" class="bg-white p-0">
                    <navigation navbarClass="navbar-light bg-white" profileSettingsRoute="/profile/settings" profileInfoRoute="/profile/info"/>
                    <div class="container-fluid p-3">
                        <router-view></router-view>
                    </div>
                </div>
                <app-footer footerClass="bg-white">
                    <common-footer-buttons></common-footer-buttons>
                </app-footer>
            </div>
        </div>
    </div>
</template>
<script>
    import CommonFooterButtons from './partials/CommonFooterButtons.vue'
    import DoctorSidebar from './partials/DoctorSidebar'
    import Navigation from './partials/Navigation'
    import Footer from './partials/Footer'

    export default {
        name: 'App',
        components: {
            'doctor-sidebar': DoctorSidebar,
            'navigation': Navigation,
            'app-footer': Footer,
            'common-footer-buttons': CommonFooterButtons
        },
        computed: {
            isUserAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
            cgaPatient() {
                return this.$store.getters.cgaPatient;
            }
        },
        data() {
            return {
                message: "hello vue",
                loadingSpinnerColor: '#24292e',
                loadingSpinnerHeight: '50px',
                loadingSpinnerWidth: '50px'
            }
        },
        mounted: function () {
            if(!this.cgaPatient)
                this.$store.dispatch("loadPatient");
        }
    }
</script>
<style lang="scss">
    #page-content {
        flex: 1 0 auto;
        background: transparent;
    }
</style>